import { j as t } from "../../../../node_modules/react/jsx-runtime.js";
import { useState as j } from "react";
import k from "../../../../node_modules/lodash/uniqueId.js";
import { clsx as w } from "../../../../node_modules/clsx/dist/clsx.m.js";
import F from "../../Icon/Icon.js";
import { FieldLabel as q } from "../components/FieldLabel/FieldLabel.js";
import D from "../components/FieldHelperText/FieldHelperText.js";
import r from "../TextField.module.scss.js";
import a from "./style.module.scss.js";
import { FieldContainer as E } from "../TextField.js";
const M = ({
  disabled: e = !1,
  helperText: m = "",
  helperTextIcon: d,
  helperTextIconTooltip: h,
  label: n,
  labelIconTooltip: v,
  optionalLabel: y,
  required: N,
  size: o = "regular",
  testId: c,
  value: p,
  status: x,
  id: g,
  autoComplete: I = "off",
  readOnly: s = !1,
  onChange: i
}) => {
  const [f, P] = j(!1), [S] = j(() => k("")), u = g || S, T = (l) => {
    i == null || i(l.target.value);
  };
  return /* @__PURE__ */ t.jsxs(
    E,
    {
      size: o,
      disabled: e,
      children: [
        n && /* @__PURE__ */ t.jsx(
          q,
          {
            label: n,
            optionalLabel: y,
            required: N,
            disabled: e,
            tooltipText: v,
            size: o,
            htmlFor: u,
            withTextField: !0
          }
        ),
        /* @__PURE__ */ t.jsxs(
          "div",
          {
            className: w(r.textField, r[o], {
              [r.textFilled]: !!p,
              [r.readOnly]: s
            }),
            "aria-disabled": e,
            "data-destructive": x === "destructive",
            children: [
              /* @__PURE__ */ t.jsx("div", { className: r.leadingIcon, children: /* @__PURE__ */ t.jsx(F, { name: "lock-01" }) }),
              /* @__PURE__ */ t.jsx(
                "input",
                {
                  type: f ? "text" : "password",
                  placeholder: "••••••••••",
                  value: p,
                  className: a.input,
                  onChange: T,
                  disabled: e,
                  "data-testid": c,
                  id: u,
                  autoComplete: I,
                  readOnly: s
                }
              ),
              /* @__PURE__ */ t.jsx(
                "button",
                {
                  className: w(a.suffix, {
                    [a.readOnly]: s
                  }),
                  disabled: e,
                  "data-testid": `${c}-show-password`,
                  onClick: (l) => {
                    if (s)
                      return l.preventDefault();
                    P(!f);
                  },
                  type: "button",
                  children: /* @__PURE__ */ t.jsx(
                    F,
                    {
                      name: "eye",
                      size: o === "regular" ? "sm" : "xs",
                      color: "#697586"
                    }
                  )
                }
              )
            ]
          }
        ),
        (m || d) && /* @__PURE__ */ t.jsx(
          D,
          {
            label: m,
            disabled: e,
            icon: d,
            tooltipText: h,
            status: x,
            withTextField: !0
          }
        )
      ]
    }
  );
};
export {
  M as default
};
//# sourceMappingURL=PasswordField.js.map
